import { render, staticRenderFns } from "./CourseBuilderPage.vue?vue&type=template&id=ef7d818c&"
import script from "./CourseBuilderPage.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CourseBuilderPage.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports